import { getGlobalVar, setGlobalVar } from "../routes/config/Config";
import axios from "axios";
const globalVar = getGlobalVar();
const API_URL = globalVar.url + "/posapi/GetOrder/?status=false";

const initialState = {
  orders: [],
};
const fetchOrders = async () => {
  try {
    //   const response = await axios.get(API_URL, {
    //     headers: {
    //       Authorization: 'Token '+globalVar.Token,
    //     },
    //   });
    //   // Filter orders where status is false
    //   const filteredOrders = response.data.filter(order => !order.status);
    // //   setOrderList(filteredOrders);
    // initialState.orders=filteredOrders;
    // //   setPrevOrder(filteredOrders);
    //   console.log("filtered orders: ",filteredOrders);
  } catch (error) {
    console.error("Error fetching orders:", error);
  }
};
fetchOrders();

const ordersReducer = (state = initialState, action) => {
  switch (action.type) {
    case "setOrders":
      return { orders: action.payload };
    case "DECREMENT":
      return { orders: [] };
    default:
      return state;
  }
};

export default ordersReducer;
